import { useCallback } from 'react';
import useStore from 'store';

export default function useSaveElement(srId: string) {
  const setElement = useStore.useSetElement();

  const ref = useCallback(
    (element: HTMLElement | null) => {
      if (element !== null) {
        setElement(srId, element);
      }
    },
    [srId, setElement]
  );

  return [ref];
}
